// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.home .search {
  margin: 15px 0;
}
.home .content {
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/home.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;AACE;EACE,cAAA;AACJ;AAEE;EACE,aAAA;EACA,uBAAA;AAAJ","sourcesContent":[".home{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .search{\n    margin: 15px 0;\n  }\n\n  .content{\n    display: flex;\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
